import { usePaymentDetail } from '@/features/approving_invoice_reports/components/PaymentDetailDrawer/context/PaymentDetailContext';
import { useTranslation } from '@/i18n';
import { ButtonV2, IconInfo } from '@moneyforward/ap-frontend-components';

import { useGetFlags } from '@/hooks/useFeatureFlag';
import classNames from 'classnames/bind';
import { FC, memo } from 'react';
import { HeaderButtons } from '../HeaderButtons';
import styles from './DrawerTitle.module.scss';

const cx = classNames.bind(styles);

export type Props = {
  onOpenApprovalRoute: () => void;
  reportId: string;
};

export const DrawerTitle: FC<Props> = memo(
  ({ onOpenApprovalRoute, reportId }) => {
    const flagEnhanceApprovalPaymentDetailDrawerUI = useGetFlags(
      'ENHANCE_APPROVAL_PAYMENT_DETAIL_DRAWER_UI'
    );
    const { titleInfo } = usePaymentDetail();
    const { t } = useTranslation();

    return (
      <div
        className={
          flagEnhanceApprovalPaymentDetailDrawerUI
            ? cx('container', 'padding-x-0')
            : cx('container')
        }
      >
        {/* Header Leading Container */}
        <div className={cx('header-leading-container')}>
          <div className={cx('info-container')}>
            {/* Payment Request Number */}
            <div className={cx('payment-request-number')}>
              <span className={cx('label')}>
                {t('approving_invoice_report_detail_number')}：
              </span>
              <span className={cx('value')}>{titleInfo.number}</span>
            </div>

            {/* Payment Request Title */}
            <div className={cx('payment-request-title')}>
              <span className={cx('label')}>
                {t('approving_invoice_report_detail_title')}：
              </span>
              <span className={cx('value')}>{titleInfo.title}</span>
              {/* Info Icon Button */}
              <div className={cx('approval-route-button')}>
                <ButtonV2
                  onClick={onOpenApprovalRoute}
                  isTransparent
                  leftIcon={<IconInfo size={0} />}
                >
                  {t('approving_invoice_report_detail_approval_route')}
                </ButtonV2>
              </div>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <HeaderButtons
          is_report_approval={titleInfo.is_report_approval}
          is_editable={titleInfo.is_editable}
          is_approvable={titleInfo.is_approvable}
          reportId={reportId}
        />
      </div>
    );
  }
);
DrawerTitle.displayName = 'DrawerTitle';
